import { ServiceUnitEnum } from 'features/salesOrder/types';

type ConfigType = {
	[key: string]: {
		typeOptions: {
			name: string;
			value: string;
			defaultValues?: {
				sale?: number;
				cost?: number;
				markup?: number;
				providerName?: string;
				setAllPax?: boolean;
				providerId?: string;
				serviceUnit?: ServiceUnitEnum;
				feeServiceType?: string;
			};
		}[];
	};
};

const IS_PROD = process.env.NODE_ENV === 'production';

function getProvider({
	prodId,
	prodName,
	testId,
	testName,
}: {
	prodId: string;
	prodName: string;
	testId: string;
	testName: string;
}) {
	return {
		providerId: IS_PROD ? prodId : testId,
		providerName: IS_PROD ? prodName : testName,
	};
}

const commonDefaults = {
	setAllPax: true,
	serviceUnit: ServiceUnitEnum.Group,
};

const providers = {
	UY: getProvider({
		prodId: 'ecfuvj9eekq9axcbfx7z8ie35sphv2nr',
		prodName: 'Mevuelo UY',
		testId: 'a0csp8uv5sxx0ncvgdcz5q88bye3964i',
		testName: 'Mevuelo UY',
	}),
	CO: getProvider({
		prodId: 'hyn2wmsjiufraqg4bxwmk9wrgr3nsb91',
		prodName: 'Mevuelo CO',
		testId: 'd2befdb1-de1e-57y4-8257-8672a26f27a9',
		testName: 'Proveedor 4',
	}),
	PY: getProvider({
		prodId: 'zdx0qnrmw9n3o1mtevonbsjttn42ceiv',
		prodName: 'Mevuelo PY',
		testId: 'd2befdb1-de1e-57y4-8257-8672a26f27a9',
		testName: 'Proveedor 4',
	}),
	BO: getProvider({
		prodId: 'jej4kkj680z4o0zk0b2efelegdj58xbh',
		prodName: 'Mevuelo BO',
		testId: 'd2befdb1-de1e-57y4-8257-8672a26f27a9',
		testName: 'Proveedor 4',
	}),
	TN: getProvider({
		prodId: 'ecfuvj9eekq9axcbfx7z8ie35sphv2nr',
		prodName: 'Mevuelo UY',
		testId: 'd2befdb1-de1e-57y4-8257-8672a26f27a9',
		testName: 'Proveedor 4',
	}),
	transferencia: getProvider({
		prodId: '4ilhdgxd55ppizd2f2y077ic3rsjl7au',
		prodName: 'Servicios Financieros S.A.',
		testId: '3vhw1wim1tdjqxj42c0s4m53any8jjjx',
		testName: 'Servicios Financieros',
	}),
	medio_pago_UY: getProvider({
		prodId: '5y89fc9qecr3zypdp04ebfg04s0qbrbl',
		prodName: 'Bamboo Payments / Siempre Pago',
		testId: '3vhw1wim1tdjqxj42c0s4m53any8jjjx',
		testName: 'Servicios Financieros',
	}),
	medio_pago_CO: getProvider({
		prodId: 'ctg3nuhbf27oaxa31shtnf0vkygcjtl7',
		prodName: 'Wompi',
		testId: '3vhw1wim1tdjqxj42c0s4m53any8jjjx',
		testName: 'Servicios Financieros',
	}),
	medio_pago_PY: getProvider({
		prodId: '08x4k7sbnbgsnxqervujhajhvcszmedo',
		prodName: 'Bancard SA',
		testId: '3vhw1wim1tdjqxj42c0s4m53any8jjjx',
		testName: 'Servicios Financieros',
	}),
	medio_pago_BO: getProvider({
		prodId: 'i7jzk9w09jh58pwpowgw33zlwz1bxz1b',
		prodName: 'ATC Red Enlace',
		testId: '3vhw1wim1tdjqxj42c0s4m53any8jjjx',
		testName: 'Servicios Financieros',
	}),
	transferencia_BO: getProvider({
		prodId: 't7xfv22tam7mh5e9hptkckuqj09931bx',
		prodName: 'Dlocal Go',
		testId: '3vhw1wim1tdjqxj42c0s4m53any8jjjx',
		testName: 'Servicios Financieros',
	}),
};

export const config: ConfigType = {
	UY: {
		typeOptions: [
			{
				name: 'Fee administrativo',
				value: 'fee_admin_corpo',
				defaultValues: {
					sale: 28,
					cost: 0,
					...providers.UY,
					...commonDefaults,
					feeServiceType: 'fee_admin_corpo',
				},
			},
			{
				name: 'Fee x servicio',
				value: 'fee_por_servicio',
				defaultValues: {
					cost: 0,
					...providers.UY,
					...commonDefaults,
					feeServiceType: 'fee_por_servicio',
				},
			},
			{
				name: 'Optimizacion',
				value: 'optimizacion',
				defaultValues: {
					sale: 0,
					...providers.UY,
					...commonDefaults,
					feeServiceType: 'optimizacion',
				},
			},
			{
				name: 'Costo de Medio de pago',
				value: 'cto_medio_de_pago',
				defaultValues: {
					sale: 0,
					...providers.medio_pago_UY,
					...commonDefaults,
					feeServiceType: 'cto_medio_de_pago',
				},
			},
			{
				name: 'Cto de transferencia',
				value: 'transferencia',
				defaultValues: {
					sale: 0,
					...providers.transferencia,
					...commonDefaults,
					feeServiceType: 'transferencia',
				},
			},
		],
	},
	CO: {
		typeOptions: [
			{
				name: 'Fee administrativo',
				value: 'fee_admin_corpo',
				defaultValues: {
					sale: 28,
					cost: 0,
					...providers.CO,
					...commonDefaults,
					feeServiceType: 'fee_admin_corpo',
				},
			},
			{
				name: 'Fee x servicio',
				value: 'fee_por_servicio',
				defaultValues: {
					cost: 0,
					...providers.CO,
					...commonDefaults,
					feeServiceType: 'fee_por_servicio',
				},
			},
			{
				name: 'Optimizacion',
				value: 'optimizacion',
				defaultValues: {
					sale: 0,
					...providers.CO,
					...commonDefaults,
					feeServiceType: 'optimizacion',
				},
			},
			{
				name: 'Costo de Medio de pago',
				value: 'cto_medio_de_pago',
				defaultValues: {
					sale: 0,
					...providers.medio_pago_CO,
					...commonDefaults,
					feeServiceType: 'cto_medio_de_pago',
				},
			},
			{
				name: 'Cto de transferencia',
				value: 'transferencia',
				defaultValues: {
					sale: 0,
					...providers.transferencia,
					...commonDefaults,
					feeServiceType: 'transferencia',
				},
			},
		],
	},
	PY: {
		typeOptions: [
			{
				name: 'Fee administrativo',
				value: 'fee_admin_corpo',
				defaultValues: {
					sale: 28,
					cost: 0,
					...providers.PY,
					...commonDefaults,
					feeServiceType: 'fee_admin_corpo',
				},
			},
			{
				name: 'Fee x servicio',
				value: 'fee_por_servicio',
				defaultValues: {
					cost: 0,
					...providers.PY,
					...commonDefaults,
					feeServiceType: 'fee_por_servicio',
				},
			},
			{
				name: 'Optimizacion',
				value: 'optimizacion',
				defaultValues: {
					sale: 0,
					...providers.PY,
					...commonDefaults,
					feeServiceType: 'optimizacion',
				},
			},
			{
				name: 'Costo de Medio de pago',
				value: 'cto_medio_de_pago',
				defaultValues: {
					sale: 0,
					...providers.medio_pago_PY,
					...commonDefaults,
					feeServiceType: 'cto_medio_de_pago',
				},
			},
			{
				name: 'Cto de transferencia',
				value: 'transferencia',
				defaultValues: {
					sale: 0,
					...providers.transferencia,
					...commonDefaults,
					feeServiceType: 'transferencia',
				},
			},
		],
	},
	BO: {
		typeOptions: [
			{
				name: 'Fee administrativo',
				value: 'fee_admin_corpo',
				defaultValues: {
					sale: 28,
					cost: 0,
					...providers.BO,
					...commonDefaults,
					feeServiceType: 'fee_admin_corpo',
				},
			},
			{
				name: 'Fee x servicio',
				value: 'fee_por_servicio',
				defaultValues: {
					cost: 0,
					...providers.BO,
					...commonDefaults,
					feeServiceType: 'fee_por_servicio',
				},
			},
			{
				name: 'Optimizacion',
				value: 'optimizacion',
				defaultValues: {
					sale: 0,
					...providers.BO,
					...commonDefaults,
					feeServiceType: 'optimizacion',
				},
			},
			{
				name: 'Costo de Medio de pago',
				value: 'cto_medio_de_pago',
				defaultValues: {
					sale: 0,
					...providers.medio_pago_BO,
					...commonDefaults,
					feeServiceType: 'cto_medio_de_pago',
				},
			},
			{
				name: 'Cto de transferencia',
				value: 'transferencia',
				defaultValues: {
					sale: 0,
					...providers.transferencia_BO,
					...commonDefaults,
					feeServiceType: 'transferencia',
				},
			},
		],
	},
	TN: {
		typeOptions: [
			{
				name: 'Costo operativo vuelos',
				value: 'cto_oper_vuelos',
				defaultValues: {
					sale: 0,
					cost: 13.64,
					markup: 0,
					...providers.TN,
					...commonDefaults,
					feeServiceType: 'cto_oper_vuelos',
				},
			},
			{
				name: 'Costo operativo alojamiento',
				value: 'cto_oper_alojamiento',
				defaultValues: {
					sale: 0,
					markup: 0,
					cost: 3.22,
					...providers.TN,
					...commonDefaults,
					feeServiceType: 'cto_oper_alojamiento',
				},
			},
			{
				name: 'Costo operativo paquetes',
				value: 'cto_oper_paquetes',
				defaultValues: {
					sale: 0,
					markup: 0,
					cost: 16.86,
					...providers.TN,
					...commonDefaults,
					feeServiceType: 'cto_oper_paquetes',
				},
			},
			{
				name: 'Costo operativo corpo',
				value: 'cto_oper_corpo',
				defaultValues: {
					sale: 0,
					markup: 0,
					cost: 18,
					...providers.TN,
					...commonDefaults,
					feeServiceType: 'cto_oper_corpo',
				},
			},
			{
				name: 'Fee administrativo',
				value: 'fee_admin_corpo',
				defaultValues: {
					sale: 28,
					cost: 28,
					...providers.TN,
					...commonDefaults,
					feeServiceType: 'fee_admin_corpo',
				},
			},
			{
				name: 'Fee x servicio',
				value: 'fee_por_servicio',
				defaultValues: {
					cost: 0,
					...providers.PY,
					...commonDefaults,
					feeServiceType: 'fee_por_servicio',
				},
			},
			{
				name: 'Optimizacion',
				value: 'optimizacion',
				defaultValues: {
					sale: 0,
					...providers.PY,
					...commonDefaults,
					feeServiceType: 'optimizacion',
				},
			},
			{
				name: 'Costo de Medio de pago',
				value: 'cto_medio_de_pago',
				defaultValues: {
					sale: 0,
					...providers.medio_pago_PY,
					...commonDefaults,
					feeServiceType: 'cto_medio_de_pago',
				},
			},
			{
				name: 'Cto de transferencia',
				value: 'transferencia',
				defaultValues: {
					sale: 0,
					...providers.transferencia,
					...commonDefaults,
					feeServiceType: 'transferencia',
				},
			},
		],
	},
};
